//import liraries
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

// define your styles
const useStyles = CreateResponsiveStyle({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#2c3e50",
  },
  contentWrapper: {
    width: "100%",
    height: "80%",
  },
  contentViewStyle:{ 
    flexDirection: "row",
    width: "100%", 
    height: "100%%" 
},
firstViewStyle:{
    width: "50%",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: "12%",
    marginVertical: "2%",
  },
  secondViewStyle:{
    width: "50%",
    justifyContent: "center",
    paddingHorizontal: "5%",
  },
  pdfViewStyle: {
    height: "60%",
    width: "100%",
  },
  textInputStyle:{
    width: 342,
    height: 56,
    borderRadius: 9,
    backgroundColor: "#ffffff",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#b9b9b9",
    marginTop: 10,
  },
  buttonContainerStyle:{ 
    flexDirection: "row", 
    marginTop: 20,
    minWidth:170,
    minHeight:30
},
btnWrapper:{
  width: 170, marginLeft: 20 
},
btnTopWrapper:{
  width: 170, 
  height: 40 
},
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 10,
  },
  overlayContentStyle: {
    width: "80%",
    height: "95%",
    backgroundColor: "white",
    borderRadius: 15,
    alignSelf:"center",
    justifyContent:"center",
    marginVertical:10
    
  },
}, {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
    },
    [DEVICE_SIZES.SM]: {
      textInputStyle:{
        width:310
      },
      btnWrapper:{
        width: 150, 
      },
      btnTopWrapper:{
        width: 150, 
      },
      buttonContainerStyle:{
        marginLeft:-20
      }
    },
    [DEVICE_SIZES.XS]: {
        contentViewStyle:{
            flexDirection:"column"
        },
        firstViewStyle:{
            width:"100%",
        },
        secondViewStyle:{
            width:"100%",
        },
        textInputStyle:{
          width:290
        },
        btnWrapper:{
          width: 140, 
        },
        btnTopWrapper:{
          width: 140, 
        },
        buttonContainerStyle:{
          marginLeft:-20
        }
    },
} );

//make this component available to the app
export default useStyles;
